import { BaseInput } from "shared/components/forms/BaseInput";
import { type CredentialFormProps } from "./types";
import { SyncOptionRadioGroup } from "./fields/SyncOptionRadioGroup";
import { BoolCheckbox } from "./fields/BoolCheckbox";
import { FormSection } from "./fields/FormSection";

export const RentvineCredentialForm = ({
  register,
  mode,
  credentialId
}: CredentialFormProps) => {
  const syncField = register("rentvine_sync");

  return (
    <>
      <BaseInput
        id="rentvine_account"
        label="Account"
        {...register("rentvine_account")}
        required
      />
      <BaseInput
        id="rentvine_api_key"
        label="API Key"
        {...register("rentvine_api_key")}
        required
      />
      <BaseInput
        id="rentvine_api_secret"
        label="API Secret"
        {...register("rentvine_api_secret")}
        required
      />

      <SyncOptionRadioGroup
        field={syncField}
        prose={
          <>
            Sync Rentvine{" "}
            <span className="font-bold">&quot;Advertising&quot;</span> status
            with the ability to submit applications
          </>
        }
      />

      {mode === "create" || credentialId != null ? (
        <FormSection title="Features">
          <BoolCheckbox
            field={register("rentvine_use_property_groups")}
            label="Use Rentvine Property Groups"
          />
        </FormSection>
      ) : (
        <p className="text-sm text-content-500">
          Open your Rentvine integration in Settings → Integration to manage
          property groups.
        </p>
      )}
    </>
  );
};
